if($('.in-index').length){

   $(document).ready(function(){  
        var myCarousels = $(".carousel");
        myCarousels.each(function( index, element  ) {
          var myCarousel = $("#"+$(element).attr('id')); 
          myCarousel.append("<ol class='carousel-indicators'></ol>");
          var indicators = $("#"+$(element).attr('id') + " .carousel-indicators"); 
          $("#"+$(element).attr('id') +" .carousel-inner").children(".item").each(function(index) {
              (index === 0) ? 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"' class='active'></li>") : 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"'></li>");
          });
        });
    });

    
  $('#products-37').after($('.footer-banners'))
  $('.homepage-group-title').each(function () {
    const $title = $(this);
    const match = this.className.match(/homepage-products-heading-(\d+)/);
    if (!match) return;
    const categoryId = match[1];
    const linkData = homepageCategoryLinks[categoryId];
    if (!linkData) return;
    if ($title.find('.homepage-category-link').length) return;
    $title.append(`
        <a href="${linkData.url}" class="homepage-category-link btn btn-secondary">
            ${linkData.text}
        </a>
    `);
    $(this).next('.products-block').after(`
      <div class="text-center customLinksProducts">
        <a href="${linkData.url}" class="homepage-category-link btn btn-secondary">
            ${linkData.text}
        </a>
      </div>  
    `)
});

}




if($('.welcome-wrapper .welcome .image').length){
   // $('.welcome-wrapper .welcome>div').prepend($('.welcome-wrapper .welcome>h1'));
    $('.welcome-wrapper .welcome>div').prepend($('.welcome-wrapper .welcome>div p.mobilni-banner'));
    $('.welcome-wrapper .welcome>div').after($('.welcome-wrapper .welcome>div .image'));
}



function loadReadingTimes($scope) {

 const urlsSet = new Set();



  $scope.find('.news-item .title[href]').each(function () {
  let href = $(this).attr('href');
  if (!href) return;

  // vždy path (/blog/...)
  if (href.indexOf('http') === 0) {
    try {
      href = new URL(href).pathname;
    } catch (e) {
      return;
    }
  }

  if (!href.endsWith('/')) {
    href += '/';
  }

  urlsSet.add(href);
});
const urls = Array.from(urlsSet);
if (!urls.length) return;

  $.ajax({
    url: 'https://www.akce-incomputer.cz/api-get-postsSK.php',
    type: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
     data: JSON.stringify({ urls }),
  success: function (response) {
    if (!response || !response.data) return;

    response.data.forEach(function (item) {
      if (!item || !item.url || !item.reading_minutes) return;

      applyReadingToArticle(item, $scope);
    });
  }
  });
}

function applyReadingToArticle(data, $scope) {

  const path = data.url.endsWith('/') ? data.url : data.url + '/';

  const $titles = $scope.find('.news-item .title[href]').filter(function () {
    let href = $(this).attr('href');
    if (!href) return false;

    if (href.indexOf('http') === 0) {
      try {
        href = new URL(href).pathname;
      } catch (e) {
        return false;
      }
    }

    if (!href.endsWith('/')) {
      href += '/';
    }

    return href === path;
  });

  if (!$titles.length) return;

  $titles.each(function () {
    const $title = $(this);
    const $item = $title.closest('.news-item');
    if (!$item.length) return;

    // ❗ zabráníme duplicitě
    if ($item.find('.blogMeta').length) return;

    const authorHtml = data.author_name
      ? `<span class="blogAuthor">
           ${data.author_image ? `<img src="${data.author_image}" alt="${data.author_name}">` : ''}
           <span>${data.author_name}</span>
         </span>`
      : '';

    const html = `
      <div class="blogMeta">
       
        <span class="blogReading">${data.reading_minutes} ${translation('minCteni')}</span>
      </div>
    `;

    $title.after(html);
    $item.find('.readBottom').prepend(authorHtml)
  });
}


(function () {

  const $blog = $('.customBlog');
  if (!$blog.length) return;

  const $blogSidebar = $blog.find('.blogSidebar');
  const $blogMain = $blog.find('.blogMain');

  /**
   * Univerzální loader sekce
   */
  function loadSection(storageKey, url, $target, afterLoad) {

    const cached = sessionStorage.getItem(storageKey);

    if (cached) {
     
      $target.append(cached);
      afterLoad && afterLoad();
      return;
    }

    $.ajax({
      type: 'GET',
      dataType: 'html',
      timeout: 10000,
      cache: true,
      url: url,
      success: function (html) {

        const doc = shoptet.common.createDocumentFromString(html);
        const content = $(doc).find('#newsWrapper').html();
        if (!content) return;

        $target.append(content);
        afterLoad && afterLoad();

        // uložíme do storage (bez h4 – řeší se níže)
        sessionStorage.setItem(storageKey, $target.html());
      }
    });
  }

  /**
   * Postprocessing obsahu
   */
  function mh_remove() {

    /* ===== MAIN ===== */
    $blogMain.find('.news-item').slice(2).remove();

    $blogMain.find('.news-item').each(function () {
      const $item = $(this);

      const $img = $item.find('img');
      if ($img.data('src')) {
        $img.attr('src', $img.data('src'));
      }

      if (!$item.find('.readMore').length) {
        const link = $item.find('.title').attr('href');
        $item.find('.text .description')
          .after(

            `<div class="readBottom"><p class="readMore">
              <a href="${link}" class="btn btn-secondary">Celý článek</a>
            </p></div>`
          );
      }
    });

    /* ===== SIDEBAR ===== */
    $blogSidebar.find('.news-item').slice(5).remove();

    $blogSidebar.find('.news-item').each(function () {
      const $img = $(this).find('img');
      if ($img.data('src')) {
        $img.attr('src', $img.data('src'));
      }
    });
  }

  /* ===== SIDEBAR ===== */
  loadSection(
    'blogSidebar',
    '/vyberame-pre-vas-to-najzaujimavejsie/',
    $blogSidebar,
    function () {
      mh_remove();
  loadReadingTimes($blogSidebar);
      // ❗ Uložíme kopii sidebaru BEZ h4
      const sidebarForStorage = $blogSidebar
        .clone()
        .find('h4')
        .remove()
        .end()
        .html();

      sessionStorage.setItem('blogSidebar', sidebarForStorage);
    }
  );

  /* ===== MAIN ===== */
 loadSection(
  'blogMain',
  '/blog/',
  $blogMain,
  function () {
    mh_remove();
    loadReadingTimes($blogMain);
  }
);


})();
